import { useEffect, type ReactNode } from 'react';

interface SheetProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

export function Sheet({ open, onClose, title, children }: SheetProps): JSX.Element | null {
  useEffect(() => {
    if (!open) return;
    function onEsc(e: KeyboardEvent) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-ink-900/40 sm:items-center" onClick={onClose}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title ?? 'Dialog'}
        onClick={e => e.stopPropagation()}
        className="w-full max-w-lg rounded-t-xl bg-paper-50 p-6 shadow-raised sm:rounded-xl"
      >
        {title ? <h2 className="mb-4 font-display text-2xl text-sage-900">{title}</h2> : null}
        {children}
      </div>
    </div>
  );
}
